import { render, staticRenderFns } from "./Survey.vue?vue&type=template&id=a23ec454&scoped=true&"
import script from "./Survey.vue?vue&type=script&lang=js&"
export * from "./Survey.vue?vue&type=script&lang=js&"
import style0 from "./Survey.vue?vue&type=style&index=0&id=a23ec454&prod&lang=scss&scoped=true&"
import style1 from "./Survey.vue?vue&type=style&index=1&id=a23ec454&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23ec454",
  null
  
)

export default component.exports